export default "__VITE_ASSET__Bfs7HtKB__"